import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=53448406&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=53448406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53448406",
  null
  
)

export default component.exports